app.service('productTabs', function (console, lazyLoad, viewPoint, productTabAccessories, productTabQuestion, productTabInstalments, productTabSendOnDevice, productTabDescription, productTabOpinions, productTabMatches, productTabServices, productCardConfig, front, broker, sufficientOutletCategory) {
	var $self,$tabs=false;
	var activeTab=false;
	var timeout;
	var tabs;
	var viewedTabs = [];

	function toggleTabs(hideTabs = false) {
		const tabNames = ['akcesoria', 'zobacz-takze', 'pasuje-do'];

		tabNames.forEach(tabName => {
			const $tab = $self.find(`.tab-${tabName}`);
			if (hideTabs) {
				$tab.addClass('is-hidden');
			} else {
				$tab.removeClass('is-hidden');
			}
		});
	}

	function open(tab,scroll){
		$tabs.removeClass('active');
		$('.tab-'+tab).addClass('active');
		activeTab=tab;
		if(viewedTabs.indexOf(tab) === -1) {
			timeout = setTimeout(function(){
				viewedTabs.push(tab);
			}, 3000);
		}
		if(scroll){
			$.scrollTo($('.tab-'+tab));
		} else {
			lazyLoad.update();
		}
	}
	function close(tab){
		$('.tab-'+tab).removeClass('active');
		activeTab=false;
	}

	function reloadTabs() {
		Object.keys(tabs).forEach(tab => {
			tabs[tab].load();
			close(tab);
		});
	}

	function loadTab(tab) {
		if (!tab.loaded) {
			tab.load();
			tab.loaded = true;
		}
	}

	function clickTab(tab, scroll){
		var tabToLoad = tabs[tab];
		if( tabToLoad ) {
			loadTab( tabToLoad );
		}
		console.log('Kliknięcie na zakładkę: '+tab);
		var text = $('#' + tab + ' > a, #' + tab + ' > h2').first().text().trim();
		if (text && tab!==activeTab) {
			UA.pageInteraction(text,  'Rozwinięcie');
		}
		if(tab===activeTab){
			close(tab);
			clearTimeout(timeout);
		}else{
			if(activeTab!==false) {
				scroll = true;
			}
			open(tab, scroll);
		}
	}
	function scrollTabByHash() {
		var hash = document.location.hash;
		switch(hash) {
			case '#akcesoria':
				clickTab('akcesoria', true);
				break;
			case '#uslugi':
				clickTab('uslugi', true);
				break;
			case '#raty':
				clickTab('raty', true);
				break;
			case '#opinie':
				clickTab('opinie', false);
				break;
			case '#reserveInStore':
				clickTab('availableIn', true);
				break;
			case '#opinionForm': case '#opinionFormAdd':
				clickTab('opinie', false);
				break;
		}
		if( hash.indexOf('#pytanie-') === 0 ) {
			clickTab('pytania', false);
			var opinionId = hash.slice(9);
			$.scrollTo( '#question-' + opinionId );
		}
		if( hash.indexOf('#opinia-') === 0 ) {
			clickTab('opinie', false);
			productTabOpinions.init();
		}
		if(hash && hash.indexOf('#pytania-')===0){
			clickTab('pytania', true);
			productTabQuestion.goToToken(hash.substr(9));
		}
	}
	function scrollToOpinionForm() {
		if(document.location.search.indexOf('mid=') > -1) {
			clickTab('opinie', false);
		}
	}
	function opinionTabQuantityChange(quantity){
		$self.find('.tab-opinions-quantity').text(`(${quantity})`);
	}
	function setEvents() {
		$self.on('click', '.tab > a, .tab > h2 > a', function(){
			var tab = $(this).data('tab');
			clickTab(tab, tab!=activeTab);
		});
		$('.js-scroll-by-hash').on('click', function(event) {
			if ($(this).attr('href').split('#')[1] == window.location.href.split('#')[1]) {
				var tabName = $(this).attr('href').split('#')[1];
				console.log(activeTab);
				if(tabName!=activeTab){
					open(tabName, true);
				}else {
					$.scrollTo($('.tab-'+tabName));
				}
			} else {
				window.location = $(this).attr('href');
			}
			event.preventDefault();
		});
		broker.on('PRODUCT_OPINION_TAB_QUANTITY_CHANGE', function (e, data){
			opinionTabQuantityChange(data);
		});
		$(window).on('hashchange', function() {
			scrollTabByHash();
		});
	}
	function setElements(){
		$self=$('#product-tabs');
		$tabs=$self.children('.tab');
		tabs = {
			'akcesoria': {
				loaded: false,
				load: productTabAccessories.init
			},
			'uslugi': {
				loaded: false,
				load: productTabServices.init
			},
			'raty': {
				loaded: false,
				load: productTabInstalments.init
			},
			'opinie': {
				loaded: false,
				load: productTabOpinions.init
			}
		};
	}
	function setProductCategory() {
		const outletCategoryId = $('.product-outlet-nav')
			.find('.is-active')
			.data('product-category');

		productCardConfig.setData({ activeOutletCategory: outletCategoryId });

		toggleTabs(!!outletCategoryId);
	}

	function hasOutletCategories() {
		return !!productCardConfig.getData().outlet;
	}
	function scrollToTab(tab, open){
		if(activeTab==tab) {
			$.scrollTo('#raty');
		}else{
			clickTab('raty', true);
		}
	}

	function init(){
		setElements();
		setEvents();
		productTabDescription.init();
		productTabMatches.init();
		productTabSendOnDevice.init();
		productTabQuestion.init();
		scrollTabByHash();
		scrollToOpinionForm();
		if (hasOutletCategories()) {
			setProductCategory();
			if (front.ole) {
				sufficientOutletCategory.init();
			}
		}
	}
	return {
		init:init,
		open:open,
		toggleTabs,
		reloadTabs,
		scrollToTab
	};
});
